import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getPropuesta () {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getNotification)
    })
  } else {
    const req = {
      url: '/api/propuestas/getpropuesta',
      method: 'GET',
      
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getPropuesta }
